import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import useActorName from 'shared/hooks/useActorName';
import useActorNames from 'shared/hooks/useActorNames';

// Dashboard-wide "who am I acting as" indicator for the top bar. Reuses the same
// persisted actor as Google Watchdog (sbly-tools:actor-name via useActorName), so
// setting it here also answers Watchdog's "Who are you?" prompt. It stamps who
// creates things (e.g. video-editing projects) — attribution, not authorization.
export default function CurrentUserMenu() {
  const [actor, setActor] = useActorName();
  const [names] = useActorNames();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        startIcon={<PersonOutlineIcon fontSize="small" />}
        sx={{
          color: actor ? 'text.primary' : 'text.secondary',
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 2,
          '&:hover': { backgroundColor: '#F1F5F9' },
        }}
      >
        {actor || 'Set user'}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {names.map((name) => (
          <MenuItem
            key={name}
            selected={name === actor}
            onClick={() => { setActor(name); setAnchorEl(null); }}
          >
            {name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
